<template>
  <div>
    <v-dialog v-model="dialog" max-width="400">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          :small="params.includes('small')"
          :x-small="params.includes('x-small')"
          :outlined="params.includes('outlined')"
          :block="params.includes('block')"
          :color="buttonColor"
          depressed
        >
          <v-icon
            v-if="iconLocation == 'left'"
            x-small
            color="primary"
            class="mx-1"
            >mdi-pencil</v-icon
          >

          Vertex Distance:{{ vertexDistanceInputVal }}mm
          <v-icon
            v-if="iconLocation == 'right'"
            x-small
            color="primary"
            class="mx-1"
            >mdi-pencil</v-icon
          >
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="d-flex flex-row align-center"
          ><div>Set Vertex Distance</div>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false" color="primary"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-3">
          <!-- <div>Choose</div> -->
          <v-btn
            v-for="val in buttonValues"
            :key="val"
            @click="setVertexDistance(val)"
            small
            depressed
            color="primary"
            :outlined="val != vertexDistanceInputVal"
            class="ma-1 btn"
            >{{ val }} mm</v-btn
          >
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import Name from "../dir/file";

export default {
  name: "VertexDistanceInput",
  props: {
    vertexDistance: null, // if want to set from external
    units: {
      type: String,
      default: "m", // or "mm"
    },
    maxVal: {
      type: Number,
      default: 24,
    },
    minVal: {
      type: Number,
      default: 5,
    },
    params: {
      type: Array,
      default: () => [],
    },
    buttonColor: {
      type: String,
      default: "primary",
    },
    iconLocation: {
      type: String,
      default: "right",
    },
  },
  data: function () {
    return { vertexDistanceInputVal: 12, dialog: false };
  },
  methods: {
    setVertexDistance(val) {
      if (!val) return;
      if (val < 0.1) val *= 1000; // if it's small assume it's in m and convert to mm
      if (val < this.minVal) val = this.minVal;
      if (val > this.maxVal) val = this.maxVal;
      this.vertexDistanceInputVal = val;
      let unit = this.units == "mm" ? 1 : 1000;
      this.$emit("newVertexDistance", val / unit);
      this.dialog = false;
    },
  },
  computed: {
    buttonValues: function () {
      let start = this.minVal;
      let stop = this.maxVal;
      return [...Array(stop + 1).keys()].slice(start);
    },
  },
  watch: {
    vertexDist: {
      handler: function (val) {
        this.setVertexDistance(val);
      },
      immediate: true,
    },
  },
  mounted() {
    if (this.vertexDistance) this.setVertexDistance(this.vertexDistance);
  },
};
</script>

<style scoped>
.btn {
  text-transform: unset !important;
}
</style>
